"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastCardStyles = void 0;

var _styledComponents = require("styled-components");

var _getColor = require("../styleHelpers/getColor");

var _getSpacing = require("../styleHelpers/getSpacing");

var toastCardStyles = {
  width: '400px',
  padding: (0, _styledComponents.css)(["", " ", " ", " ", ""], (0, _getSpacing.getSpacing)(5), (0, _getSpacing.getSpacing)(7), (0, _getSpacing.getSpacing)(5), (0, _getSpacing.getSpacing)(5)),
  borderRadius: '6px',
  backgroundColor: (0, _getColor.getColor)('gray', '800'),
  color: (0, _getColor.getColor)('common', 'blackContrastText'),
  shadow: ['0px 4px 20px rgba(0, 0, 0, 0.2)']
};
exports.toastCardStyles = toastCardStyles;